import { ChecklistItem } from "."

export const FolderPermissions = ({ forConfirmed }) => {
    return <ChecklistItem forConfirmed={forConfirmed}>Keep projects private between team members with folder permissions</ChecklistItem>
}